import { Helmet } from '@xing-com/crate-helmet';
import fontXingSansBoldWoff2 from '@xing-com/fonts/assets/XING-Sans-Bold.woff2';
import fontXingSansRegularWoff2 from '@xing-com/fonts/assets/XING-Sans-Regular.woff2';

import { BaseStyles } from './base-styles';
import { NormalizeStyles } from './normalize-styles';

const fonts = [
  { fontWeight: 400, woff2: fontXingSansRegularWoff2 },
  { fontWeight: 700, woff2: fontXingSansBoldWoff2 },
];

const fontsString = fonts
  .map(({ fontWeight, woff2 }) => {
    return `
      @font-face {
        font-family: 'XING Sans';
        font-display: block;
        font-style: normal;
        font-weight: ${fontWeight};
        src: url(${woff2}) format("woff2");
      }`;
  })
  .join('')
  .replace(/\n|^\s+/gm, '');

const bodyStyles = `body {font-family: 'XING Sans', 'Trebuchet MS', Arial, 'Helvetica Neue', sans-serif;}`;

const links = fonts.map(({ woff2 }, i) => {
  return (
    <link
      key={i}
      href={woff2}
      rel="preload"
      as="font"
      crossOrigin="anonymous"
      type="font/woff2"
    />
  );
});

const GlobalStyles: React.FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  return (
    <>
      <NormalizeStyles />
      <BaseStyles />
      <Helmet>
        <meta name="viewport" content="width=device-width, minimum-scale=1" />
        {links}
        <style>{fontsString}</style>
        <style>{bodyStyles}</style>
      </Helmet>
      {children}
    </>
  );
};
export default GlobalStyles;
